import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import banner from "./banner.module";
import profile from "./profile.module";
import company from "./company.module";
import campaign from "./campaign.module";
import receipt_type from "./receipt_type.module";
import customer_campaign_receipt from "./customer_campaign_receipt.module";
import customer_campaign_point from "./customer_campaign_point.module";
import customer_campaign_receipt_message from "./customer_campaign_receipt_message.module";
import customer_campaign_receipt_reward from "./customer_campaign_receipt_reward.module";
import unapproced_reason from "./unapproced_reason.module";
import custom_color from "./custom_color.module";
import company_management from "./company_management.module";
import user from "./user.module";
import userType from "./userType.module";
import campaign_announce_reward from "./campaign_announce_reward.module";
import campaign_announce_reward_customer from "./campaign_announce_reward_customer.module";
import campaign_announce_reward_message from "./campaign_announce_reward_message.module";
import company_registration_setting from "./company_registration_setting.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    banner,
    profile,
    company,
    campaign,
    receipt_type,
    customer_campaign_receipt,
    customer_campaign_point,
    customer_campaign_receipt_message,
    customer_campaign_receipt_reward,
    unapproced_reason,
    custom_color,
    company_management,
    company_registration_setting,
    user,
    userType,
    campaign_announce_reward,
    campaign_announce_reward_customer,
    campaign_announce_reward_message
  }
});
